<template>
    <div name="contact-modal" ref="contactModal">
        <div class="p-24 p-md-40">
            <contact-form :translations="translations" :sharpspring-endpoint="sharpspringEndpoint" :google-analytics-event-label="googleAnalyticsEventLabel"></contact-form>
            <span class="close" @click="$modal.hide(modalName)"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        translations: {
            type: Object,
            required: true
        },

        googleAnalyticsEventLabel: {
            type: String,
            required: false
        },

        sharpspringEndpoint: {
            type: String,
            required: false
        }
    },

    computed: {
        modalName() {
            return this.$refs.contactModal.closest(".v--modal-overlay").getAttribute('data-modal');
        }
    }
}
</script>